

































import BaseComponent from "@/asdcom/BaseComponent";
import { Component } from "vue-property-decorator";
import util from "@/lib/util";
import {
  ApplicantsTasksDto,
  ApplicantRequestTaskDto,
  ICurrentCustomerUserProfileDto
} from "@/asdcom/apiproxy/apiproxy.dto";
import OnlineUserComponent from "@/components/vcponlineok/staff-user/online-user-component.vue";
import { IHeader } from "@/store/models/staff/IHeader";
import bus from "@/components/vcponlineok/bus/bus.js";

@Component({
  components: {
    OnlineUserComponent
  }
})
export default class ApplicantRequests extends BaseComponent {
  isDetailsVisible?: boolean = false;
  valid: boolean = false;
  requestType = util.abp.constant.userSubmissionType.values;
  selectedProfile: ICurrentCustomerUserProfileDto | null = null;
  headers: IHeader[] = [
    { text: "Received Date", value: "receivedDate", align: "center" },
    { text: "Request Type", value: "requestType", align: "center" },
    { text: "Applicant Name", value: "applicantName", align: "center" },
    { text: "Applicant Email", value: "applicantEmail", align: "center" }
  ];
  
  get requests(): ApplicantRequestTaskDto[] | undefined {
    var ret = this.$store.getters["vcponlineok/getApplicantRequestTaskList"];
    return ret;
  }

  async created() {
    this.$appsvs.vcpOnlineOkStaff.refreshTaskCounts();
    this.getApplicantRequest();
  }

  async getApplicantRequest() {
    await this.$appsvs.vcpOnlineOkStaff.retrieveAndCachApplicantRequests();
  }

  mounted() {
    bus.$on("returnToListView", () => {
      this.getApplicantRequest();
      this.isDetailsVisible = false;
    })
    bus.$on('refreshList', () => {
      this.getApplicantRequest();
      this.$appsvs.vcpOnlineOkStaff.refreshTaskCounts();
    })
  }

  beforeDestroy() {
    bus.$off("returnToListView");
    bus.$off("refreshList");
  }

  async onRequestItemClick(item: any) {
    // get user profile.
    this.selectedProfile = await this.$appsvs.customerUser.getCustomerUserProfileByUserId(
      item.requestedByUserId
    );
    // show details.
    this.isDetailsVisible = !!this.selectedProfile;
  }
}
